import { Helmet } from "react-helmet-async";

const SITE_URL = "https://zoooz.app";
const DEFAULT_TITLE = "Zoooz – מאגר מידע פילנתרופי לחברות ותרומות עסקיות";
const DEFAULT_DESCRIPTION =
  "Zoooz הוא מאגר מידע פילנתרופי ייעודי למגזר העסקי – כולל תרומות של חברות ישראליות, קשר עם מנהלי אחריות תאגידית, דוחות ESG ומידע מדויק למגייסי תרומות.";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  ogImage?: string;
  noindex?: boolean;
}

export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  ogImage = DEFAULT_OG_IMAGE,
  noindex = false,
}: SEOProps) {
  const fullTitle = title ? `${title} | Zoooz` : DEFAULT_TITLE;
  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
